export enum OID {
  Template = "0",
  Julian = "52",
  Firzen = "51",
  LouisEX = "50",
  Bat = "38",
  Justin = "39",
  Knight = "37",
  Jan = "36",
  Monk = "35",
  Sorcerer = "34",
  Jack = "33",
  Mark = "32",
  Hunter = "31",
  Bandit = "30",
  Deep = "1",
  John = "2",
  Henry = "4",
  Rudolf = "5",
  Louis = "6",
  Firen = "7",
  Freeze = "8",
  Dennis = "9",
  Woody = "10",
  Davis = "11",
  Weapon0 = "100",
  Weapon_Stick = "100",
  Weapon2 = "101",
  Weapon_Hoe = "101",
  Weapon4 = "120",
  Weapon_Knife = "120",
  Weapon5 = "121",
  Weapon_baseball = "121",
  Weapon6 = "122",
  Weapon_milk = "122",
  Weapon1 = "150",
  Weapon_Stone = "150",
  Weapon3 = "151",
  Weapon_WoodenBox = "151",
  Weapon8 = "123",
  Weapon_Beer = "123",
  Weapon9 = "124",
  Weapon_Boomerang = "124",
  Weapon10 = "217",
  Weapon_LouisArmourA = "217",
  Weapon11 = "218",
  Weapon_LouisArmourB = "218",
  Criminal = "300",
  JohnBall = "200",
  HenryArrow1 = "201",
  RudolfWeapon = "202",
  DeepBall = "203",
  HenryWind = "204",
  DennisBall = "205",
  WoodyBall = "206",
  DavisBall = "207",
  HenryArrow2 = "208",
  FreezeBall = "209",
  FirenBall = "210",
  FirenFlame = "211",
  FreezeColumn = "212",
  Weapon7 = "213",
  Weapon_IceSword = "213",
  JohnBiscuit = "214",
  DennisChase = "215",
  JackBall = "216",
  JanChaseh = "219",
  JanChase = "220",
  FirzenChasef = "221",
  FirzenChasei = "222",
  FirzenBall = "223",
  BatBall = "224",
  BatChase = "225",
  JustinBall = "226",
  JulianBall = "228",
  JulianBall2 = "229",
  Etc = "998",
  BrokenWeapon = "999"
}
export const OIDDescriptions: Record<OID, string> = {
  [OID.Template]: "",
  [OID.Julian]: "",
  [OID.Firzen]: "",
  [OID.LouisEX]: "",
  [OID.Bat]: "",
  [OID.Justin]: "",
  [OID.Knight]: "",
  [OID.Jan]: "",
  [OID.Monk]: "",
  [OID.Sorcerer]: "",
  [OID.Jack]: "",
  [OID.Mark]: "",
  [OID.Hunter]: "",
  [OID.Bandit]: "",
  [OID.Deep]: "",
  [OID.John]: "",
  [OID.Henry]: "",
  [OID.Rudolf]: "",
  [OID.Louis]: "",
  [OID.Firen]: "",
  [OID.Freeze]: "",
  [OID.Dennis]: "",
  [OID.Woody]: "",
  [OID.Davis]: "",
  [OID.Weapon0]: "",
  [OID.Weapon2]: "",
  [OID.Weapon4]: "",
  [OID.Weapon5]: "",
  [OID.Weapon6]: "",
  [OID.Weapon1]: "",
  [OID.Weapon3]: "",
  [OID.Weapon8]: "",
  [OID.Weapon9]: "",
  [OID.Weapon10]: "",
  [OID.Weapon11]: "",
  [OID.Criminal]: "",
  [OID.JohnBall]: "",
  [OID.HenryArrow1]: "",
  [OID.RudolfWeapon]: "",
  [OID.DeepBall]: "",
  [OID.HenryWind]: "",
  [OID.DennisBall]: "",
  [OID.WoodyBall]: "",
  [OID.DavisBall]: "",
  [OID.HenryArrow2]: "",
  [OID.FreezeBall]: "",
  [OID.FirenBall]: "",
  [OID.FirenFlame]: "",
  [OID.FreezeColumn]: "",
  [OID.Weapon7]: "",
  [OID.JohnBiscuit]: "",
  [OID.DennisChase]: "",
  [OID.JackBall]: "",
  [OID.JanChaseh]: "",
  [OID.JanChase]: "",
  [OID.FirzenChasef]: "",
  [OID.FirzenChasei]: "",
  [OID.FirzenBall]: "",
  [OID.BatBall]: "",
  [OID.BatChase]: "",
  [OID.JustinBall]: "",
  [OID.JulianBall]: "",
  [OID.JulianBall2]: "",
  [OID.Etc]: "",
  [OID.BrokenWeapon]: "",
}

export const O_ID = OID;
export type O_ID = OID;
export const BuiltIn_OID = OID;
export type BuiltIn_OID = OID;

export const SurvivalRankOids: readonly string[] = [
  OID.Deep, OID.John, OID.Henry, OID.Rudolf, OID.Louis,
  OID.Firen, OID.Freeze, OID.Dennis, OID.Woody, OID.Davis,
]